import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

export function News() {
    return (
        <div style={{ backgroundColor: '#f5f5f5', minHeight: '100vh', padding: '50px 0' }}>
          <Container>
            <Row>
              <Col md={{ span: 8, offset: 2 }}>
                <div style={{ backgroundColor: '#fff', padding: '30px', borderRadius: '15px', boxShadow: '0px 10px 20px rgba(0, 0, 0, 0.1)', fontFamily: "'Playfair', serif", fontSize: '20px', lineHeight: '1.6' }}>
                  <h2 style={{ textAlign: 'center', marginBottom: '30px' }}>Upcoming Performances</h2>
                  
                  <div>
                    <h3>June 14/2025, 19:30</h3>
                    <p>Piano Recital: <i>Goyescas</i></p>
                    <p>@ Schwartzsche Villa, Berlin</p>
                  </div>
                  
                  <hr style={{ margin: '40px 0', borderColor: '#ddd' }} />
                  
                  <div>
                    <h3>July 15/2025, 20:00</h3>
                    <p>Piano Recital: <i>Goyescas</i></p>
                    <p>@ Piano Salon Christophori, Berlin</p>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
    );
}
